import {
  TBridgeMap,
  IVersionDic,
  OS,
  withErrorHandler,
  createVersionChecker,
  os,
} from './index';

const iosVersionDic: IVersionDic = {
  moveExternalWebBrowser: [{ version: '00.00.00' }],
  moveInternalWebBrowser: [{ version: '00.00.00' }],
  closeScreen: [{ version: '00.00.00' }],
  movePassMain: [{ version: '00.00.00' }],
  showTermsScreen: [{ version: '00.00.00' }],
  moveExternalSvc: [{ version: '00.00.00' }],
  showErrorPage: [{ version: '00.00.00' }],
  onCloseNativeTerm: [{ version: '00.00.00' }],
  moveFinInst: [{ version: '00.00.00' }], // todo 06.23.02
};
const aosVersionDic: IVersionDic = {
  moveExternalWebBrowser: [{ version: '00.00.00' }],
  moveInternalWebBrowser: [{ version: '00.00.00' }],
  closeScreen: [{ version: '00.00.00' }],
  movePassMain: [{ version: '00.00.00' }],
  showTermsScreen: [{ version: '00.00.00' }],
  moveExternalSvc: [{ version: '00.00.00' }],
  showErrorPage: [{ version: '00.00.00' }],
  onCloseNativeTerm: [{ version: '00.00.00' }],
  moveFinInst: [{ version: '00.00.00' }], // todo 06.26.02
};

const encodeLgu = (param: any) => {
  try {
    param = typeof param === 'string' ? param : JSON.stringify(param);
    return btoa(encodeURIComponent(param));
  } catch (e) {
    return param;
  }
};

const encodeBase64UrlSafe = (param: any) => {
  try {
    param = typeof param === 'string' ? param : JSON.stringify(param);
    return btoa(param).replace(/\//g, '_').replace(/\+/g, '-');
  } catch (e) {
    return param;
  }
};

const createBridgeLgu = (os: OS) => {
  const iosRequest = (method: any, args: any) => {
    console.log('lgu ios', method, args);
    args = args ?? {};
    args = Object.entries(args)
      .map((e) => e.join('='))
      .join('&');
    window.location.href = `jscall://${method}?${args}`;
  };

  const iosReceive = (eventName: any, callback: any) => {
    console.log(eventName, callback);
    window[eventName] = callback;
  };

  const aosRequest = (method: any, args: any) => {
    console.log('lgu aos', method, args);
    if (method === 'moveExternalSvc') {
      const { moveVasCd, url } = args;
      window?.passLoanJS[method](moveVasCd, url);
    } else if (method === 'moveExternalWebBrowser') {
      const { url } = args;
      window?.passLoanJS[method](url);
    } else if (method === 'moveInternalWebBrowser') {
      const { url, showGNB, titleInfo } = args;
      window?.passLoanJS[method](url, showGNB, titleInfo);
    } else if (method === 'moveFinInst') {
      const { tabSeq, parameters } = args;
      window?.passLoanJS[method](tabSeq, parameters);
    } else {
      window?.passLoanJS[method]();
    }
  };

  const aosReceive = (eventName: any, callback: any) => {
    window[eventName] = callback;
  };

  const bridge = (request: any, receive: any) => {
    return {
      moveExternalWebBrowser: ({ url }: any) =>
        request('moveExternalWebBrowser', { url }),
      moveInternalWebBrowser: ({ url, showGNB, titleInfo }: any) =>
        request('moveInternalWebBrowser', { url, showGNB, titleInfo }),
      closeScreen: () => request('closeScreen'),
      movePassMain: () => request('movePassMain'),
      showTermsScreen: () => request('showTermsScreen'),
      moveExternalSvc: ({ moveVasCd, url }: any) =>
        request('moveExternalSvc', { moveVasCd, url }),
      showErrorPage: () => request('showErrorPage'),
      onCloseNativeTerm: ({ callback }: any) =>
        receive('onCloseNativeTerm', callback),
      moveFinInst: ({ tabSeq, parameters }: any) =>
        request('moveFinInst', { tabSeq, parameters }),
    };
  };

  const request = os === OS.IOS ? iosRequest : aosRequest;
  const receive = os === OS.IOS ? iosReceive : aosReceive;

  return bridge(request, receive);
};

const bridgeLguMap: TBridgeMap = (bridgeLgu, errorHandler, versionChecker) => {
  return {
    getParamInfo: (params) => {
      const { appUserId, appUserPartIdx, parameters } = params;
      const { os_type, track_cd, userKey, ctn, srcCd, src_cd } = params;
      let rParams: any = {};
      try {
        rParams = atob(parameters) || {};
        if (
          rParams &&
          typeof rParams === 'string' &&
          rParams.startsWith('%7b')
        ) {
          rParams = decodeURIComponent(rParams);
        }
        rParams = JSON.parse(rParams);
      } catch {}
      return {
        ctn: ctn,
        mgntCd: userKey,
        osType: os_type,
        srcCd: (rParams.src_cd || rParams.srcCd || srcCd || src_cd) ?? '',
        trackCd: track_cd ?? '',
        queueSeq: rParams.queue_seq ?? '',
        appUserId: appUserId,
        appUserPartIdx: appUserPartIdx,
        // todo app version 추가
        version: '99.99.99',
      };
    },
    getAppVersion: () => {
      // todo app version 추가
      return {
        version: '99.99.99',
      };
    },
    openNativeWebView: ({ url, title, closeType }) => {
      withErrorHandler(
        () =>
          bridgeLgu.moveInternalWebBrowser({
            url: encodeLgu(url),
            showGNB: 'Y',
            titleInfo: encodeLgu({
              title,
              leftButtonType: closeType === 'B' ? 'back' : 'none',
              rightButtonType: 'none',
            }),
          }),
        versionChecker.moveInternalWebBrowser(),
        errorHandler,
      );
    },
    close: () => {
      withErrorHandler(
        () => bridgeLgu.closeScreen(),
        versionChecker.closeScreen(),
        errorHandler,
      );
    },
    openExternalBrowser: (obj = { url: '' }) => {
      withErrorHandler(
        () => bridgeLgu.moveExternalWebBrowser({ url: encodeLgu(obj.url) }),
        versionChecker.moveExternalWebBrowser(),
        errorHandler,
      );
    },
    goNativeMain: () => {
      withErrorHandler(
        () => bridgeLgu.movePassMain(),
        versionChecker.movePassMain(),
        errorHandler,
      );
    },
    showTerms: () => {
      withErrorHandler(
        () => bridgeLgu.showTermsScreen(),
        versionChecker.showTermsScreen(),
        errorHandler,
      );
    },
    requestAddService: ({ type, url }: any) => {
      console.log(type, url);
      if (type === 'EBMP') {
        // tabSeq 탭이름 path;
        // 1 대출탭 /loan
        // 2 카드탭 /card
        // 3 보험탭 /insurance
        // 4 예적금탭 /saving
        // 5 모아보기탭 /
        // parameters 에는 track_cd_type
        const u = new URLSearchParams(url);
        const tabSeq = u.get('tabSeq');
        const track_cd_type = u.get('track_cd_type');
        const redirectYn = u.get('redirectYn');
        const parameters = {
          track_cd_type: track_cd_type,
          srcCd: track_cd_type,
          redirectYn: redirectYn ?? 'N',
        };

        withErrorHandler(
          () =>
            bridgeLgu.moveFinInst({
              tabSeq: tabSeq,
              parameters: encodeBase64UrlSafe(parameters),
            }),
          versionChecker.moveFinInst(),
          errorHandler,
        );
      }
    },
    showErrorPage: () => {
      withErrorHandler(
        () => bridgeLgu.showErrorPage(),
        versionChecker.showErrorPage(),
        errorHandler,
      );
    },
    onCloseNativeTerm: (callback: any) => {
      withErrorHandler(
        () => bridgeLgu.onCloseNativeTerm({ callback }),
        versionChecker.onCloseNativeTerm(),
      );
    },
  };
};

export default (appVersion: string, errorHandler: () => void) => {
  const checker = createVersionChecker(
    appVersion,
    os === OS.IOS ? iosVersionDic : aosVersionDic,
  );
  const bridge = createBridgeLgu(os);

  return bridgeLguMap(bridge, errorHandler, checker);
};
